import Logo from "../../components/items/Logo"
import googleLogo from "../../assets/icons/google.svg"
import '../../css/UserForms.css'
import AppContext from "../../context/AppContext"
import { useState, useRef, useContext } from "react"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"

function Login() {
    const [showPassword, setShowPassword] = useState(false);
    const [forms, setForms] = useState({
        password: '',
        passwordFocus: false,
        institution: '',
        institutionFocus: false
    })
    const { goHome } = useContext(AppContext)

    const {
        password, 
        passwordFocus, 
        institution, 
        institutionFocus 
    } = forms

    const [errors, setErrors] = useState({
        instErr: '',
        passErr: ''
    })

    const {
        instErr,
        passErr
    } = errors

    const instRef = useRef()
    const passwordRef = useRef();

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setForms(values => ({...values, [name]: value}))
    }

    const togglePasswordVisibility = () => {
        setShowPassword((value) => !value);
        passwordRef.current.focus();
    }

    // const clearInputs = () => {
    //     setForms({
    //         password: '',
    //         passwordFocus: false,
    //         institution: '',
    //         institutionFocus: false
    //     })
    // }

    const resetErrors = () => {
        for(const error in errors){
          setErrors(values => ({...values, [error]: ''}))
        }
    }

    const addError = (errName, err) => {
        setErrors(values => ({...values, [errName]: err}))
    }

    const resetBorders = () => {
        instRef.current.classList.remove("err")
        passwordRef.current.classList.remove("err")
    }

    const validateInputs = () => {
        if(!institution){
            addError('instErr', "Please enter the institution's name")
            instRef.current.classList.add("err")
        }
        if(!password){
            addError('passErr', "Please enter your password")
            passwordRef.current.classList.add("err")
        }
    }

    const onSubmit = (e) => {
        e.preventDefault();
        resetErrors()
        resetBorders()
        validateInputs()
        console.log(
            {
                institution,
                password,
            }
        )
    }
    

  return (
    <motion.main 
        className="user-form" 
        id="login"
        initial={{width: 0}}
        animate={{width: '100%'}}
        exit={{x: window.innerWidth, transition: { duration: 0.1 }}}
    >
        <div className='medbolt-logo' onClick={goHome}>
            <Logo/>
        </div>
        <h1>Log in</h1>
        <form noValidate onSubmit={onSubmit} className="login-form">
            <div className="google-auth">
                <img src={googleLogo} alt="google logo"/>
                Continue with Google
            </div>
            <div className="or">
                <hr />
                <span>or</span>
                <hr />
            </div>
            <div className="user-input">
                <label htmlFor="institution" style={{color: institutionFocus ? "#486FD8" : "black"}} >Name of institution</label>
                <input ref={instRef} type="text" required id="institution" name="institution" value={institution || ""} onChange={handleChange} 
                
                style={{marginBottom: !instErr && '2.5rem'}}
                onFocus={
                    () => {
                        setForms(values => ({...values, institutionFocus: true}))
                    }
                }
                onBlur={
                    () => {
                        setForms(values => ({...values, institutionFocus: false}))
                    }
                }
                />
                {instErr && <div className="error">{instErr}</div>}
            </div>
            <div className="user-input">
                <label style={{color: passwordFocus ? "#486FD8" : "black"}} htmlFor="password">Password</label>
                <div id="pass">
                    <input ref={passwordRef} required id="password" type={showPassword ? "text" : "password"} name="password" value={password || ""} onChange={handleChange}
                    onFocus={
                        () => {
                            setForms(values => ({...values, passwordFocus: true}))
                        }
                    }
                    onBlur={
                        () => {
                            setForms(values => ({...values, passwordFocus: false}))
                        }
                    }
                    />
                    {passErr && <div className="error">{passErr}</div>}
                    <span title={showPassword ? "hide password" : "show password"} onClick={togglePasswordVisibility}>{!showPassword ? <i className="fa-regular fa-eye"></i> : <i className="fa-regular fa-eye-slash"></i>}</span>
                </div>
                <Link className="forgot link" to='/forgot_password'>forgot password?</Link>
            </div>
            <button className="trynow" type="submit">Log in</button>
            <p className="signup_text">Already have an account? <Link to="/trynow" className="link">Sign up</Link></p>
        </form>
    </motion.main>
  )
}

export default Login